import { render, staticRenderFns } from "./rule-template.vue?vue&type=template&id=6c6fd47c&scoped=true&"
import script from "./rule-template.vue?vue&type=script&lang=js&"
export * from "./rule-template.vue?vue&type=script&lang=js&"
import style0 from "./rule-template.vue?vue&type=style&index=0&id=6c6fd47c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6fd47c",
  null
  
)

export default component.exports